<div class="grid-desktop-3 grid-tablet-1 grid-mobile-1 root-container">

  <app-card header="Laatste factuur" class="recent-invoice-card">
    <app-badge ngProjectAs="[badge]" icon="file-lines" size="small"/>

    @if (latestInvoice !== null) {
      <div class="info-list grid-desktop-2 grid-tablet-2 grid-mobile-2 no-padding">
        <div>Factuurnummer:</div>
        <div>{{ latestInvoice.invoice_number }}</div>
        <div>Factuurdatum:</div>
        <div>{{ latestInvoice.invoice_date | date:"dd-MM-yyyy" }}</div>
        <div>Bedrag:</div>
        <div>
          <app-currency [value]="latestInvoice.amount_incl || 0"/>
        </div>
        <div>Status:</div>
        <div>
          <app-payment-status [isPaid]="latestInvoice.is_paid"/>
        </div>
      </div>
    } @else {
      <span>Binnenkort verschijnt hier je eerste factuur.</span>
    }


    @if (latestInvoice !== null) {
      <app-button
        ngProjectAs="[button]"
        type="primary"
        (click)="this.download(latestInvoice)">
        Downloaden
      </app-button>
    }
    @if (latestInvoice !== null) {
      <app-button
        ngProjectAs="[button]"
        type="outline"
        (click)="this.showInvoice(latestInvoice)">
        Bekijken
      </app-button>
    }
  </app-card>

  @if (subscriptions.length === 1) {
    <app-card header="Mijn abonnement" class="single-subscription-card">
      <app-badge size="small" icon="address-card" ngProjectAs="[badge]"/>
      <div class="info-list grid-desktop-2 grid-tablet-2 grid-mobile-2 no-padding">
        <div>Abonnement:</div>
        <div>{{ subscriptions[0].id }}</div>
        <div>Adres:</div>
        <div>{{ subscriptions[0].address | address }}</div>
        <div>Status:</div>
        <div>{{ SubscriptionStateLabel[subscriptions[0].state] }}</div>
      </div>
      <app-button type="outline" ngProjectAs="[button]" (click)="router.navigate(['/dashboard/subscription'])">
        Bekijken
      </app-button>
    </app-card>
  }

  @if (subscriptions.length !== 1) {
    <app-card header="Mijn abonnementen" class="recent-subscription-card">
      <app-badge size="small" icon="address-card" ngProjectAs="[badge]"/>
      <ng-container>
        <div class="info-list grid-desktop-3 grid-tablet-4 grid-mobile-2 no-padding">
          <div class="text-bold">Abonnement</div>
          <div class="text-bold mobile-hidden">Adres</div>
          <div class="text-bold">Status</div>
          @for (subscription of subscriptions | slice:0:5; track subscription) {
            <a [attr.aria-label]="'Abonnement ' + subscription.id" class="subscription-id link-text-only" routerLink="/dashboard/subscription"
              (click)="authService.setSelectedSubscription(subscription)"
              (keydown.enter)="authService.setSelectedSubscription(subscription)" tabindex="">
              {{ subscription.id }}
            </a>
            <div class="mobile-hidden">{{ subscription.address | address }}</div>
            <div>{{ SubscriptionStateLabel[subscription.state] }}</div>
          }
        </div>
      </ng-container>
      <app-button type="outline" ngProjectAs="[button]" (click)="router.navigate(['/dashboard/subscription'])">
        Bekijken
      </app-button>
    </app-card>
  }

  <app-card header="Mijn meldingen" class="col-span-desktop-2 recent-tickets-card">
    <app-badge size="small" icon="ticket" ngProjectAs="[badge]"/>
    @if (recentTickets.length) {
      <div class="info-list grid-desktop-5 grid-tablet-4 grid-mobile-2 no-padding">
        <div class="text-bold">Melding</div>
        <div class="text-bold mobile-hidden">Abonnement</div>
        <div class="text-bold mobile-hidden tablet-hidden">Geüpdatet</div>
        <div class="text-bold mobile-hidden">Status</div>
        <div class="text-bold"></div>
        @for (recentTicket of recentTickets; track recentTicket) {
          <a [attr.aria-label]="'Melding ' + recentTicket.ticket_id" class="ticket-id link-text-only"
            [routerLink]="'/dashboard/customersupport/tickets/' + recentTicket.ticket_id">
            {{ recentTicket.ticket_id }}
          </a>
          <div class="mobile-hidden">{{ recentTicket.subscr_id || 'N.v.t' }}</div>
          <div class="mobile-hidden tablet-hidden">{{ recentTicket.updated_at | timeAgo }}</div>
          <div class="mobile-hidden">{{ TicketStateLabel[recentTicket.state_description] }}</div>
          <div class="indicator">
            @if (recentTicket.unread_messages) {
              <app-count-indicator [count]="recentTicket.unread_messages"/>
            }
          </div>
        }
      </div>
    } @else {
      <span>Je hebt momenteel geen meldingen. Heb je een vraag of probleem? Maak een melding aan!</span>
    }
    @if (!this.maxTicketsForRelationReached) {
      <app-button ngProjectAs="[button]"
        (click)="router.navigate(['/dashboard/customersupport/tickets/new'])">
        Nieuwe melding
      </app-button>
    }
    <app-button type="outline" ngProjectAs="[button]" (click)="router.navigate(['/dashboard/customersupport/tickets'])">
      Alles bekijken
    </app-button>
  </app-card>

  <app-card header="Hulp nodig?" class="opinion-card">
    <app-badge size="small" icon="circle-question" ngProjectAs="[badge]"></app-badge>
    <span>{{this.config.support.needHelpText}}</span>
    <app-button type="outline" ngProjectAs="[button]" (click)="router.navigate(['/dashboard/customersupport'])">
      Klantenservice
    </app-button>
  </app-card>
</div>
